import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { getWalletCreditsData } from 'services/business';
import { formatMoney } from 'utils/wallet';

import { notify } from 'components/Notify/Notify';
import MerchantInfoCard from '../cards/MerchantInfoCard/MerchantInfoCard';
import LoadingWrapper from 'components/LoadingWrapper/LoadingWrapper';

import './WalletCreditSection.less';

const WalletCreditSection = ({ businessData, ...props }) => {
  const intl = useIntl();
  const [walletCreditsData, setWalletCreditsData] = useState({
    wallet: null,
    credits: null
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!businessData?._id) {
      return;
    }

    const fetchWalletCreditsData = async () => {
      setIsLoading(true);
      const queryParams = {
        businessId: businessData?._id
      };
      try {
        const {
          data: { totalWalletBalance, bostaCreditsBalance }
        } = await getWalletCreditsData(queryParams);

        setWalletCreditsData({
          wallet: totalWalletBalance,
          credits: bostaCreditsBalance
        });
      } catch (error) {
        notify(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchWalletCreditsData();
  }, [businessData]);

  return (
    <LoadingWrapper loading={isLoading}>
      <div className="br-merchant-wallet-credit ">
        <MerchantInfoCard
          label={intl.formatMessage({
            id: 'merchant_analysis.financial_metrics.wallet_balance'
          })}
          value={formatMoney(walletCreditsData?.wallet)}
        />
        <MerchantInfoCard
          label={intl.formatMessage({
            id: 'merchant_analysis.financial_metrics.bosta_credits'
          })}
          value={formatMoney(walletCreditsData?.credits)}
        />
      </div>
    </LoadingWrapper>
  );
};

export default WalletCreditSection;
